import React from "react"
import {Box, Stack, Typography} from "@mui/material";
import {CmCollection} from "../../../../packages/graphql-layer/src";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import useWindowSize from "../../../utility/useWindowSize";
import {showSecondLayer} from "@s-group/react-usercentrics";
import {useTranslation} from "react-i18next";


export interface Props {
    cmCollection: CmCollection,
    CAEGlobalSettings: any,
    pageProps?: any
}

const privacySettingStyle = {
    fontSize: '1rem',
    cursor: 'pointer',
    paddingTop: '8px',
    paddingBottom: '8px',
    letterSpacing: '0.17px',
    lineHeight: '143%',
};


function C074CopyrightNavi(props: Props) {
    const {t} = useTranslation();
    const {lowerThanWindowLarge, lowerThanWindowSmall} = useWindowSize();

    const gridStyle = {
        alignSelf: 'start',
        width: '100%',
        height: '100%',
        padding: '24px 16px 16px 16px',
    }

    const stackStyleCenter = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
    }

    const copyRightStyle = {
        fontSize: 16,
        fontFamily: '"HelveticaNeueLTStd", Helvetica, Arial, sans-serif',
        paddingBottom: 1
    }

    const noStackStyle = {}
    return (<>
            <Box sx={gridStyle}>
                <Stack direction="row" alignItems="center" gap={4}
                       style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}>
                    <Typography
                        sx={copyRightStyle}> &copy; {new Date().getFullYear()} {props.CAEGlobalSettings["copyright"]} </Typography>
                </Stack>
                <Stack direction={lowerThanWindowSmall ? 'column' : 'row'} alignItems="center"
                       gap={lowerThanWindowSmall ? 0 : 4}
                       style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}>
                    {
                        props.cmCollection.items?.map((item: any, index) => (
                            <CCOLinkable dataCypress={'copyRightLink' + index}
                                         type={"footer"} key={index} target={item}
                                         name={item.teaserTitle}/>
                        ))
                    }
                    <Typography data-cypress='privacySettingsLink' variant='linkLabel' color={"primary.main"} sx={privacySettingStyle}
                                onClick={() => showSecondLayer()}>
                        {t('c074_privacy_settings')}
                    </Typography>
                </Stack>
            </Box>
        </>
    )
}

export default C074CopyrightNavi